import {useEffect} from "react";

const CITY_SELECT = 'select[name="deal[custom_field][cf_event_city]"]';

// The Freshsales form names a few cities differently from us. Keyed by our city slug.
const FORM_CITY_NAMES = {
    "ho-chi-minh-city": "Saigon",
    "marbella": "Marabella",
    "marseille": "Marseilles",
    "new-york": "New York City",
    "portland-oregon": "Portland",
};

// "Washington D.C." and "Washington, DC", or "San Sebastián" and "San Sebastian", are the same city.
const normalise = (name) => name.normalize("NFKD").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

// Picks the page's city in the embedded Freshsales lead form ("What city are you interested in?").
// The form is injected by a third-party script some time after the page loads, so we wait for it.
export default function usePreselectLeadFormCity(city) {
    const name = city?.name;
    const slug = city?.slug;

    useEffect(() => {
        if (!name) {
            return;
        }

        const slugKey = (slug ?? "").replace(/\//g, "").toLowerCase();
        const wanted = [name, FORM_CITY_NAMES[slugKey]].filter(Boolean).map(normalise);

        // true once there is nothing left to wait for
        const preselect = () => {
            const select = document.querySelector(CITY_SELECT);

            // not injected yet, or select2 hasn't taken it over yet (it would show a stale value)
            if (!select || !select.classList.contains("select2-hidden-accessible")) {
                return false;
            }

            if (select.value) {
                return true;
            }

            const option = [...select.options].find((o) => o.value && wanted.includes(normalise(o.text)));
            if (option) {
                select.value = option.value;
                // select2 updates what it displays on "change"
                select.dispatchEvent(new Event("change", {bubbles: true}));
            }

            return true;
        };

        if (preselect()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (preselect()) {
                observer.disconnect();
            }
        });
        observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ["class"]});

        return () => observer.disconnect();
    }, [name, slug]);
}
